import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Dashboard from '../Dashboard';
import SecurityDashboard from './SecurityDashboard';

/**
 * Smart Dashboard Router
 * Routes users to their appropriate dashboard based on role
 */
export default function DashboardRouter() {
  const navigate = useNavigate();
  const { user, isAuthenticated } = useAuth();
  
  useEffect(() => {
    if (!isAuthenticated) {
      navigate('/login');
      return;
    }
    
    // Route to role-specific dashboard
    const role = user?.role;
    
    switch (role) {
      case 'security':
        // Security guards get their own specialized dashboard
        navigate('/security-dashboard', { replace: true });
        break;
      case 'provider':
        // Providers go to supplier dashboard
        navigate('/supplier-dashboard', { replace: true });
        break;
      case 'empleado':
        // Empleados go to their tasks
        navigate('/home/tasks', { replace: true });
        break;
      case 'familiar':
        // Familiar gets the home lens dashboard
        navigate('/home/dashboard', { replace: true });
        break;
      // propietario and sub_admin use default dashboard (LensDashboard)
      default:
        // All other roles use the main dashboard
        // Dashboard component handles role-based content internally
        break;
    }
  }, [user?.role, isAuthenticated, navigate]);
  
  // Render the appropriate dashboard
  const role = user?.role;
  
  if (role === 'security') {
    return <SecurityDashboard />;
  }
  
  // Default to main dashboard with role-based content
  return <Dashboard />;
}
